<div class="release-notes-content">
    <div class="release-note-wrapper">
        <div class="gtw-web-components list-header">
            <label>Release Notes</label>
            <input type="text" class="form-control" [(ngModel)]="searchReleaseNotes" placeholder="Search Notes..." />
            @if (access>= 4) {
<ap-button [btnType]="'secondary'" [label]="'Add New Release Note'" styleClass="notes-btn" (onClick)="addReleaseNotes()"></ap-button>
}
        </div>
        <div class="notes-list">
            @if ((releaseNotesList | datafilter : {RN_TITLE:searchReleaseNotes} ); as notesList) {

                @for (list of notesList; track $index) {
<li (click)="selectNotes(list)">{{list.RN_TITLE? list.RN_TITLE: ''}}</li>
}
            
}
        </div>
    </div>
    <div class="release-note-update-wrapper">
        @if (releaseNotesDataBlockEnable) {
<div>
            <div class="panel panel-default" style="margin-bottom: 0;">
                <div class="panel-heading gtw-web-components" style="display: flex;">
                    {{selectedNotes.RN_TITLE? selectedNotes.RN_TITLE: 'Add Release Notes'}} 
                    &nbsp;@if (notesListSelected) {
<span> (Updated on {{selectedNotes.UPDATED_ON}})</span>
}
                    @if (access>= 4 && notesListSelected) {
<ap-button [btnType]="'secondary'" [label]="'Edit Notes'" styleClass="notes-btn" style="margin-left: auto;" (onClick)="editNotes()"></ap-button>
}
                    @if (access>= 4 && notesListSelected) {
<ap-button [btnType]="'secondary'" [label]="'Delete Notes'" styleClass="notes-btn" style="margin-left: 10px;" (onClick)="deleteReleaseNotes()"></ap-button>
}
                </div>
                <div class="panel-body">
                    @if (!editorEnable) {
<div>
                        <iframe id="frame" class="notes-view-class" sandbox="allow-same-origin allow-scripts" seamless="true" srcdoc="{{selectedNotes.RN_BODY? selectedNotes.RN_BODY: ''}}"></iframe>
                    </div>
}
                    @if (editorEnable) {
<div>
                        <div>
                            <label>Release Notes Title:</label>
                            <input type="text" class="form-control" [(ngModel)]="editedNotesTitle"/>
                        </div>
                        <div>
                            <label>Release Notes:</label>
                            <ap-text-editor
                                [styleClass]="'rel-notes-editor'"
                                [style]="'background: white; display: block;'"
                                [(data)]="notesBody"
                                [config]="releaseNotesEditorConfig"
                                (dataChange)="changeNotesBody($event)">
                            </ap-text-editor>
                        </div>
                        <!-- <div>
                            <label>Client Specific:</label>
                            <input type="checkbox" class="form-control" />
                        </div>
                        <div>
                            <label>Clients:</label>
                            <ap-dropdown
                                formControlName="reasonEIN"
                                [list]="reasonsEIN"
                                [selectType]="'single'"
                                [inputAriaLabel]="'Clients'"
                            >
                                <ap-dropdown-list-item *ngFor="let item of reasonsEIN" [item]="item"></ap-dropdown-list-item>
                            </ap-dropdown>
                        </div> -->
                    </div>
}
                </div>
            </div>
            @if (enableSaveBtn) {
<div class="gtw-web-components notes-footer">
                <ap-button [btnType]="'primary'" [label]="'Save'" style="margin-left: auto;" (onClick)="saveReleaseNoteData()" [disabled]="!((editedNotesTitle.length > 0) && (notesBody.length > 0))"></ap-button>
            </div>
}
        </div>
}
        @if (!releaseNotesDataBlockEnable) {
<div class="no-notes">
            <h4>Select/Add Release Notes to View</h4>
        </div>
}
    </div>
</div>